import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartnerLayout = lazy(() => import("@/pages/partner/PartnerLayout"));

export const Route = createFileRoute("/partner")({
  component: () => <PartnerLayout />,
});
